import { action } from 'satcheljs';

export default action('INITIALIZE_INBOX_RULES_FOLDER_STORE');
